import React from 'react'

import { Container } from 'react-bootstrap'
import { CloseButton, Description, DescriptionLight, Headline } from '../../Components/CustomComponent'
import DigitalTimer from '../../Components/DigitalTimer'
import styles from "./styles/RemainingTime.module.scss"
import { ACCOUNT_ENUM } from './Route'
import { QUIZ_STATUS } from '../../constants'
import { useNavigate } from 'react-router-dom'

export default function RemainingTime({ data, setPage }) {
    const navigate = useNavigate();


    const handleTimerEnd = () => {
        setPage(ACCOUNT_ENUM.ROLE_SELECTION, {
            ...data,
            status: QUIZ_STATUS.UPCOMING
        })
    }

    const handleBackClick = () => {
        return navigate(-1);
    }

    return (
        <Container className={styles.RemainingTime}>
            <CloseButton onClick={handleBackClick} classes="mb-3" />
            <div className={styles.coverImage}>
                <img
                    src={data.cover_image_url}
                    alt="Cover Image"
                    className={styles.image}
                />
            </div>
            <div className={styles.content}>
                <DescriptionLight
                    text={`${data.quiz_questions_count || data.quiz_questions.length || data.question_count || 0} Question(s)`}
                    size='55'
                    classes='mt-3'
                />
                <Headline
                    text={data.title}
                    classes='mt-3 mb-4'
                />
                <Description
                    text="Starts in"
                    size='5'
                    classes='text-center mt-5 mb-4'
                />
                <div className='d-flex justify-content-center'>
                    <DigitalTimer end_date={data.start_at} onTimeEnd={handleTimerEnd} />
                </div>
            </div>
        </Container>
    )
}
